module.exports = __webpack_public_path__ + "6a7ff41feb016e7e44755925af4e5404.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/empty-owlstagram/winter-owl.png
// module id = 510
// module chunks = 0